export default __webpack_public_path__ + "static/media/react.6c1d44b8.svg";